import React, { useEffect, useRef, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import SimpleSelect from "../../components/selects/simpleSelect";
import { Divider, Grid, useMediaQuery } from "@mui/material";
import FormTextField from "../../components/textField/formTextField";
import LaddaButton from "../../components/buttons/laddaButton";
import FormRadioButton from "../../components/formRadioButton";
import { icons } from "../../constants";
import SelectSerieNumber from "./modals/selectSerieNumberModal";
import AddSerieNumber from "./modals/addSerieNumberModal";
import {
  callApiAsync,
  getAdverseEventsBiomedicalEquipment,
  getCallBiomedicalEquipmentBySerie,
  getCallSelectsBiomedicalEquipment,
  getBiomedicalEquipmentModelAdverseEvents,
  getBiomedicalEquipmentModelAccessories,
  getBiomedicalEquipmentModels,
  getSelectsBiomedical,
  postSaveBiomedicalEquipment
} from "../../services/apiService";
import FormCalendar from "../../components/calendar/formCalendar";
import ToastNotification from "../../components/toastNotification";
import ImageUploadButton from "../../components/ImageUploadBtn";
import { useDispatch, useSelector } from "react-redux";
import SimpleTable from "../../components/tables/simpleTable";
import LoadingFeedback, { useLoadingState } from "../../components/loadingFeedback";
import AddAccessoryBase from "./modals/addAccessoryBase";
import { setBiomedicalId } from "../../redux/slices/biomedicalSlice";
import { useNavigate } from "react-router-dom";
import { yesNoSelect } from "../../utils/burnData";
import AddUbicationModal from "./modals/addUbicationModal";
import AdverseEventsTable from "./adverseEventsTable";
import { format } from "date-fns";
import { StyledTooltip } from "../../components/toolltipComponent";
import { getTooltipContent } from "../../utils/biomedicalEquipmentUtils";
import HistoryModalBiomedical from "./modals/historyModalBiomedical";
import { parseDateAsLocal } from "../../utils/dateUtils";
import VerificationModal from "../../components/modals/verificationModal";
import { hasAnyRoleUtil } from "../../utils/AuthorizedUtils/360Report";
import { BIOMEDICAL_INVENTORY_EDIT_ROLES } from "../../constants/biomedicalRoles";

const urlApi = process.env.REACT_APP_API_URL;
const baseAccessoryColumns = [{ field: "accessory", header: "Accesorio" }];

const validationSchema = yup.object().shape({
  name: yup.string().required("Este campo es obligatorio"),
  statusText: yup.string().required("Este campo es obligatorio"),
  brand: yup.string().required("Este campo es obligatorio"),
  modelId: yup
    .number()
    .typeError("Este campo es obligatorio")
    .required("Este campo es obligatorio"),
  quantity: yup
    .number()
    .typeError("La cantidad debe ser un número")
    .integer("La cantidad debe ser un número entero")
    .required("Este campo es obligatorio"),
  importer: yup.string().required("Este campo es obligatorio"),
  useful_life: yup
    .number()
    .typeError("Debe ser un número")
    .integer("Debe ser un número entero")
    .min(3, "Mínimo 3 años")
    .max(15, "Máximo 15 años")
    .required("Este campo es obligatorio"),
  producer: yup.string().required("Este campo es obligatorio"),
  classificationRisk: yup.string().required("Este campo es obligatorio"),
  importDate: yup.date().required("Este campo es obligatorio"),
  manufacturingDate: yup.date().nullable()
});

const BiomedicalEquipmentBase = ({ isViewer, onBusyChange }) => {
  const [loadingDetails, setLoadingDetails] = useLoadingState(true);
  const [initialDetailsLoaded, setInitialDetailsLoaded] = useState(false);
  useEffect(() => {
    if (!loadingDetails) setInitialDetailsLoaded(true);
  }, [loadingDetails]);
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const [openSelectSerieNumberModal, setOpenSelectSerieNumberModal] =
    useState(false);
  const [openAddSerieNumberModal, setOpenAddSerieNumberModal] = useState(false);
  const [openAddAccessoryModal, setOpenAddAccessoryModal] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);

  const [brandOptions, setBrandOptions] = useState([]);
  const [importerOptions, setImporterOptions] = useState([]);
  const [producerOptions, setProducerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [classificationRiskOptions, setClassificationRiskOptions] = useState(
    []
  );
  const [biomedicalEquipmentId, setBiomedicalEquipmentId] = useState(0);
  const [serieIdSelected, setSerieIdSelected] = useState(null);
  const [serieSelected, setSerieSelected] = useState("");
  const [biomedicalEquipmentData, setBiomedicalEquipmentData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [imageProcessing, setImageProcessing] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [imageSaving, setImageSaving] = useState(false);
  const imageProcessingRef = useRef(false);
  const storedImageRef = useRef(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [accessoryTable, setAccessoryTable] = useState([]);
  const [brandIdSelected, setBrandIdSelected] = useState(null);
  const [severityState, setSeverityState] = useState("success");
  const [adverseEventsSelect, setAdverseEvents] = useState([]);
  const [adverseEventTypeOptions, setAdverseEventTypeOptions] = useState([]);
  const [adverseEventGravityOptions, setAdverseEventGravityOptions] = useState([]);
  const [installedSelect, setInstalledSelect] = useState([]);
  const [biomedicalEquipmentState, setBiomedicalEquipmentState] = useState([]);
  const [currentLocationSelect, setCurrentLocationSelect] = useState([]);
  const [openAddUbication, setOpenAddUbication] = useState(false);
  const [adverseEventsDataTable, setAdverseEventsDataTable] = useState([]);
  const [usefulLifeState, setUsefulLifeState] = useState([]);
  const [openVerification, setOpenVerification] = useState(false);
  const protectedActionRef = useRef(null);
  const [activeAction, setActiveAction] = useState(null);
  const [isSavingEquipment, setIsSavingEquipment] = useState(false);
  useEffect(() => {
    onBusyChange?.(!!activeAction);
  }, [activeAction, onBusyChange]);
  const startProtectedAction = (action) => {
    if (protectedActionRef.current !== null) return false;
    protectedActionRef.current = action;
    setActiveAction(action);
    return true;
  };
  const endProtectedAction = () => {
    protectedActionRef.current = null;
    setActiveAction(null);
  };

  const handleConfirmSave = async () => {
    if (protectedActionRef.current !== "confirming") return;
    protectedActionRef.current = "save";
    setActiveAction("save");
    setIsSavingEquipment(true);
    try {
      await handleSubmit(onSubmit)();
    } finally {
      setIsSavingEquipment(false);
      if (protectedActionRef.current !== "navigating") {
        protectedActionRef.current = "confirming";
        setActiveAction("confirming");
      }
    }
  };

  const navigate = useNavigate();

  const userData = useSelector((state) => state.userData.userData);
  const userId = userData.id;
  const canEditInventory = hasAnyRoleUtil(
    BIOMEDICAL_INVENTORY_EDIT_ROLES,
    userData.roleList
  );

  const biomedicalId = useSelector((state) => state.biomedical.biomedicalId);
  const serieIdRedux = useSelector(
    (state) => state.biomedical.equipementSerieId
  );

  const loadModelOptions = (brandId, nextModelId = null, legacyModelName = "") => {
    const numericBrandId =
      brandId != null && brandId !== "" ? Number(brandId) : NaN;

    if (!Number.isFinite(numericBrandId) || numericBrandId <= 0) {
      setModelOptions([]);
      setValue("modelId", "");
      return;
    }

    callApiAsync(
      () => getBiomedicalEquipmentModels(numericBrandId),
      (data) => {
        const rows = data || [];
        setModelOptions(rows);

        if (nextModelId != null && nextModelId !== "") {
          setValue("modelId", Number(nextModelId));
          return;
        }

        if (legacyModelName) {
          const match = rows.find(
            (row) =>
              String(row.name).trim().toLowerCase() ===
              String(legacyModelName).trim().toLowerCase()
          );
          setValue("modelId", match ? Number(match.value) : "");
          return;
        }

        setValue("modelId", "");
      },
      setLoadingDetails
    );
  };

  const onChangeBrand = (event) => {
    const brandIdCurrent = event?.target?.value ?? getValues("brand");
    setBrandIdSelected(brandIdCurrent);
    updateAccessoryTable([]);
    updateAdverseEventsDataTable([]);
    loadModelOptions(brandIdCurrent);
  };

  const hasAccessoryWithZeroQuantity = () =>
    accessoryTable.some((item) => {
      const quantity =
        item?.quantity != null && item.quantity !== ""
          ? Number(item.quantity)
          : null;
      return quantity === 0;
    });

  const sanitizeAccessoryTableForEquipmentSave = () =>
    accessoryTable.map((item) => {
      const quantity =
        item?.quantity != null && item.quantity !== ""
          ? Number(item.quantity)
          : null;

      return {
        ...item,
        quantity:
          quantity != null &&
          Number.isFinite(quantity) &&
          Number.isInteger(quantity) &&
          quantity > 0
            ? quantity
            : null
      };
    });

  const handleOpenVerification = () => {
    if (isViewer || !isValid || imageProcessingRef.current || !startProtectedAction("confirming")) return;
    if (hasAccessoryWithZeroQuantity()) {
      setSeverityState("warn");
      setToastMessage("Hay accesorios con cantidad 0.");
      setShowToast(true);
    }
    setOpenVerification(true);
  };
  const handleCloseVerification = () => {
    if (protectedActionRef.current !== "confirming") return;
    setOpenVerification(false);
    endProtectedAction();
  };

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    reset,
    watch,
    formState: { errors, isValid }
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all"
  });
  const statusValue = watch("status");
  const brandValue = watch("brand");
  const modelIdValue = watch("modelId");

  const updateAccessoryTable = (nextValue) => {
    setAccessoryTable((prevData) =>
      typeof nextValue === "function" ? nextValue(prevData) : nextValue
    );

    if (Number(biomedicalEquipmentId) > 0 || Number(biomedicalEquipmentData?.id) > 0) {
      trigger();
    }
  };

  const updateAdverseEventsDataTable = (nextValue) => {
    setAdverseEventsDataTable((prevData) =>
      typeof nextValue === "function" ? nextValue(prevData) : nextValue
    );

    if (Number(biomedicalEquipmentId) > 0 || Number(biomedicalEquipmentData?.id) > 0) {
      trigger();
    }
  };

  const options = [
    { label: "Registro Sanitario", value: 1 },
    { label: "Permiso de comercialización", value: 2 }
  ];

  const getAdverseEventsDataTable = () => {
    callApiAsync(
      () => getAdverseEventsBiomedicalEquipment(biomedicalEquipmentId),
      (data) => {
        updateAdverseEventsDataTable(data);
      },
      setLoadingDetails
    );
  };

  useEffect(() => {
    getSelectsBiomedicalEquipment();
    if (serieIdRedux) {
      setSerieIdSelected(serieIdRedux);
    }
  }, []);

  useEffect(() => {
    getAdverseEventsDataTable(biomedicalEquipmentId);
  }, [biomedicalEquipmentId]);

  useEffect(() => {
    const numericModelId =
      modelIdValue != null && modelIdValue !== "" ? Number(modelIdValue) : NaN;

    if (
      Number(biomedicalEquipmentId) > 0 ||
      Number(biomedicalEquipmentData?.id) > 0
    ) {
      return;
    }

    if (!Number.isFinite(numericModelId) || numericModelId <= 0) {
      updateAdverseEventsDataTable([]);
      return;
    }

    callApiAsync(
      () => getBiomedicalEquipmentModelAdverseEvents(numericModelId, userId),
      (data) => {
        const rows = (data?.table || []).map((row) => ({
          id: 0,
          rowTableId: `model-${numericModelId}-${row.typeEventId}-${row.gravityLevelId}`,
          type_event_id: row.typeEventId,
          gravity_level_id: row.gravityLevelId,
          amount: null
        }));
        updateAdverseEventsDataTable(rows);
      },
      setLoadingDetails
    );
  }, [biomedicalEquipmentData?.id, biomedicalEquipmentId, modelIdValue, userId]);

  useEffect(() => {
    const numericModelId =
      modelIdValue != null && modelIdValue !== "" ? Number(modelIdValue) : NaN;

    if (
      Number(biomedicalEquipmentId) > 0 ||
      Number(biomedicalEquipmentData?.id) > 0
    ) {
      return;
    }

    if (!Number.isFinite(numericModelId) || numericModelId <= 0) {
      updateAccessoryTable([]);
      return;
    }

    callApiAsync(
      () => getBiomedicalEquipmentModelAccessories(numericModelId, userId),
      (data) => {
        const rows = (data?.table || []).map((row) => ({
          id: row.accessoryId,
          accessoryId: row.accessoryId,
          accessory: row.accessory,
          partNumberAccessory: row.partNumberAccessory,
          quantity: row.quantity,
          brandSpecificId: null
        }));
        updateAccessoryTable(rows);
      },
      setLoadingDetails
    );
  }, [biomedicalEquipmentData?.id, biomedicalEquipmentId, modelIdValue, userId]);

  useEffect(() => {
    const hasPersistedSerie =
      serieIdSelected != null && Number(serieIdSelected) !== 0;
    const hasNewSerieDraft =
      Number(serieIdSelected) === 0 && String(serieSelected || "").trim() !== "";

    setValue("serieText", serieSelected);

    if (hasPersistedSerie) {
      getBiomedicalEquipmentBySerie();
    } else if (hasNewSerieDraft) {
      cleanData(true);
    } else {
      cleanData();
    }
  }, [serieSelected, biomedicalId, serieIdSelected]);

  const hadleModalClose = () => {
    setOpenSelectSerieNumberModal(false);
  };

  const hadleModalCloseAdd = () => {
    setOpenAddSerieNumberModal(false);
  };

  const hadleCloseAddAccessory = () => {
    setOpenAddAccessoryModal(false);
  };

  const getSelectsBiomedicalEquipment = async () => {
    callApiAsync(
      () => getCallSelectsBiomedicalEquipment(),
      (data) => {
        setBrandOptions(data.brands);
        setClassificationRiskOptions(data.riskClassifications);
        setProducerOptions(data.producers);
        setImporterOptions(data.importers);
      },
      setLoadingDetails
    );
  };

  const getSelectsBiomedicalData = () => {
    callApiAsync(
      () => getSelectsBiomedical(),
      (data) => {
        setInstalledSelect(data.installed);
        setAdverseEvents(data.adverseEvents);
        setAdverseEventTypeOptions(data.adverseEventTypes || []);
        setAdverseEventGravityOptions(data.adverseEventGravities || []);
        setBiomedicalEquipmentState(data.state);
        setCurrentLocationSelect(data.ubication);
        setUsefulLifeState(data.usefulLife);
      },
      setLoadingDetails
    );
  };

  const getBiomedicalEquipmentBySerie = async (serieIdR) => {
    callApiAsync(
      () =>
        getCallBiomedicalEquipmentBySerie(
          serieIdR == null ? serieIdSelected : serieIdR
        ),
      (data) => {
        setBiomedicalEquipmentData(data);
        setBiomedicalEquipmentId(data.id);
        loadData(data);
        updateAccessoryTable(data.accessories);
      },
      (active) => { setLoadingDetails(active); setImageLoading(active); }
    );
  };

  useEffect(() => {
    getSelectsBiomedicalData();
  }, []);

  const loadData = (data) => {
    setSelectedImageFile(null);
    if (data.imagePath) {
      const correctedImagePath = data.imagePath.replace(/\\/g, "/");
      const newImagePath = correctedImagePath.replace(
        "biomedicalEquipment/",
        ""
      );
      const finalImageUrl = `${urlApi}${newImagePath}`;
      setSelectedImage(finalImageUrl);
      storedImageRef.current = finalImageUrl;
    } else {
      setSelectedImage("");
      storedImageRef.current = null;
    }

    setBrandIdSelected(data.brandId);

    setValue(
      "manufacturingDate",
      data.manufacturingDate ? parseDateAsLocal(data.manufacturingDate) : null
    );
    setValue(
      "serieText",
      data.serieName == null ? serieSelected : data.serieName
    );
    setValue("name", data.name);
    setValue("brand", data.brandId);
    loadModelOptions(data.brandId, data.modelId, data.model);
    setValue("quantity", data.amount);
    setValue("importer", data.importerId);
    setValue("producer", data.producerId);
    setValue("useful_life", data.useful_life_id);
    setValue("classificationRisk", data.riskClassificationId);
    setValue(
      "importDate",
      data.importDate ? parseDateAsLocal(data.importDate) : null
    );
    setValue("status", data.healthOrMarketing);
    setValue("statusText", data.healthOrMarketingText);
    setValue(
      "installed",
      data.installed === 1 ? 1 : data.installed === 0 ? 0 : null
    );
    if (data.installationDate) {
      setValue(
        "installationDate",
        data.installationDate ? parseDateAsLocal(data.installationDate) : null
      );
    }
    if (data.marketingDate) {
      setValue(
        "marketingDate",
        data.marketingDate ? parseDateAsLocal(data.marketingDate) : null
      );
    }
    setValue("adverseEvents", data.adverseEventId);
    setValue("state", data.stateId);
    setValue("currentLocation", data.currentLocationId);
  };

  const cleanData = (preserveSerie = false) => {
    setBiomedicalEquipmentData([]);
    setBiomedicalEquipmentId(0);
    setSelectedImage(null);
    setSelectedImageFile(null);
    storedImageRef.current = null;
    setBrandIdSelected(null);
    updateAccessoryTable([]);
    updateAdverseEventsDataTable([]);
    reset({
      serieText: preserveSerie ? serieSelected : "",
      name: "",
      brand: "",
      modelId: "",
      quantity: "",
      importer: "",
      producer: "",
      useful_life: "5",
      classificationRisk: "",
      importDate: null,
      status: "",
      statusText: "",
      installed: "",
      installationDate: null,
      marketingDate: null,
      adverseEvents: "",
      state: "",
      currentLocation: ""
    });
    setModelOptions([]);
  };

  const handleImageChange = (file) => {
    setSelectedImageFile(file);
    setSelectedImage(file ? URL.createObjectURL(file) : storedImageRef.current);
  };
  useEffect(() => () => { if (selectedImage?.startsWith("blob:")) URL.revokeObjectURL(selectedImage); }, [selectedImage]);

  const onSubmit = async (formData) => {
    if (imageProcessingRef.current) return;
    if (serieIdSelected == null) {
      return;
    }
    const accessoryTableForSave = sanitizeAccessoryTableForEquipmentSave();
    const accessoryIds = accessoryTableForSave.map(
      (item) => item.accessoryId || item.id
    );

    const combinedData = {
      requestId: crypto.randomUUID(),
      id: biomedicalEquipmentId,
      name: formData.name,
      brandId: formData.brand,
      modelId: formData.modelId,
      amount: formData.quantity,
      importerId: formData.importer,
      producerId: formData.producer,
      useful_life_id: formData.useful_life,
      riskClassificationId: formData.classificationRisk,
      importDate: format(new Date(formData.importDate), "yyyy-MM-dd"),
      healthOrMarketing: formData.status,
      healthOrMarketingText: formData.statusText,
      serieId: serieIdSelected,
      serieName: serieSelected,
      adverseEventsDataTable: JSON.stringify(adverseEventsDataTable),
      accessoryIds: JSON.stringify(accessoryIds),
      accessoryTable: JSON.stringify(accessoryTableForSave),
      installedValue:
        getValues("installed") === 1
          ? 1
          : getValues("installed") === 0
            ? 0
            : null,
      installationDate:
        getValues("installationDate") === null
          ? null
          : getValues("installed") === 1
            ? format(new Date(formData.installationDate), "yyyy-MM-dd")
            : null,
      marketingDate:
        getValues("marketingDate") === null
          ? null
          : format(new Date(formData.marketingDate), "yyyy-MM-dd"),
      adverseEvents: getValues("adverseEvents"),
      state: getValues("state"),
      currentLocation: getValues("currentLocation"),
      userId: userId,
      manufacturingDate: formData.manufacturingDate
        ? format(new Date(formData.manufacturingDate), "yyyy-MM-dd")
        : null
    };

    if (selectedImageFile) combinedData.image = selectedImageFile;

    await callApiAsync(
      () => postSaveBiomedicalEquipment(combinedData),
      (data) => {
        setBiomedicalEquipmentId(data.biomedicalEquipmentId);
        dispatch(setBiomedicalId(data.biomedicalEquipmentId));

        setSeverityState(data.warning ? "warn" : "success");
        setToastMessage(data.warning || "Equipo biomédico guardado con éxito");
        getSelectsBiomedicalEquipment();
        setShowToast(true);

        protectedActionRef.current = "navigating";
        setOpenVerification(false);
        navigate("/biomedicalManagementDashboard/manageDevice");
      },
      (saving) => setImageSaving(saving && !!selectedImageFile)
    );
  };

  return (
    <div>
      <fieldset disabled={!!activeAction} inert={activeAction ? "" : undefined}
        style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
      <div className="IHContainer j-space-between mb-20">
        <p className="createRist-title ml-0">Datos del Equipo Biomédico</p>
        <LaddaButton
          variant="contained"
          color={"#404040"}
          backgroundColor={"#F4D658"}
          width={"210px"}
          height={"35px"}
          margin={"0"}
          onClick={() => {
            setHistoryModalOpen(true);
          }}
        >
          <div className="IHContainer align-center">
            <img
              className="btn-icon mr-10"
              src={icons.time_history}
              alt="icon"
            />
            <p className="button_text">Última Actualización</p>
          </div>
        </LaddaButton>
      </div>
      {/* <form onSubmit={handleSubmit(onSubmit)}> */}
      <LoadingFeedback loading={loadingDetails && !initialDetailsLoaded} rows={8}>
      <form onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        handleOpenVerification();
      }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} md={8}>
            <p className="create-label ml-0">
              Nro. de Serie: <span className="red-text">*</span>
            </p>
            <Grid container spacing={2} item xs={12} md={12}>
              <Grid item xs={8}>
                <FormTextField
                  name="serieText"
                  control={control}
                  formLabel=""
                  label=""
                  disabled
                  margin={"0"}
                />
              </Grid>
              <Grid item xs={4} className="VContainer align-end">
                {serieIdSelected && serieIdSelected !== 0 ? (
                  <></>
                ) : (
                  <LaddaButton
                    height={"42px"}
                    width={"42px"}
                    margin={"0 5px"}
                    variant="contained"
                    type="button"
                    onClick={() => setOpenAddSerieNumberModal(true)}
                  >
                    <img className="btn-icon" src={icons.plusIcon} alt="icon" />
                  </LaddaButton>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="form-group">
              <p className="create-label m-0 ml-0">
                Imagen del equipo biomédico
              </p>
              <ImageUploadButton
                onProcessingChange={(busy) => {
                  if (busy && imageProcessingRef.current) return false;
                  imageProcessingRef.current = busy; setImageProcessing(busy); return true;
                }}
                allowClear={!!selectedImageFile}
                onImageChange={handleImageChange}
                buttonText="Agregar Imagen"
                path={selectedImage}
                loading={imageLoading || imageSaving}
                isViewer={isViewer}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            <FormRadioButton
              name="status"
              control={control}
              label=""
              options={options}
              error={errors.status}
              flexible={true}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            {statusValue && (
              <FormTextField
                name="statusText"
                control={control}
                formLabel=""
                label=""
                error={errors.statusText}
                margin={"0"}
                disabled={isViewer}
              />
            )}
          </Grid>
          {/* first row */}
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Nombre del Equipo: <span className="red-text">*</span>
            </p>
            <FormTextField
              name="name"
              control={control}
              formLabel=""
              label=""
              error={errors.name}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Marca: <span className="red-text">*</span>
            </p>
            <SimpleSelect
              name="brand"
              control={control}
              options={brandOptions}
              error={errors.brand}
              hideLabel={true}
              onChange={onChangeBrand}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Modelo: <span className="red-text">*</span>
            </p>
            <SimpleSelect
              name="modelId"
              control={control}
              options={modelOptions}
              error={errors.modelId}
              hideLabel={true}
              margin={"0"}
              disabled={isViewer || !brandValue}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Cantidad: <span className="red-text">*</span>
            </p>
            <FormTextField
              name="quantity"
              control={control}
              formLabel=""
              label=""
              error={errors.quantity}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Importador: <span className="red-text">*</span>
            </p>
            <SimpleSelect
              name="importer"
              control={control}
              options={importerOptions}
              error={errors.importer}
              hideLabel={true}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Fabricante: <span className="red-text">*</span>
            </p>
            <SimpleSelect
              name="producer"
              control={control}
              options={producerOptions}
              error={errors.producer}
              hideLabel={true}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          {/* third row */}
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Clasificación por riesgo: <span className="red-text">*</span>
            </p>
            <SimpleSelect
              name="classificationRisk"
              control={control}
              options={classificationRiskOptions}
              error={errors.classificationRisk}
              hideLabel={true}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Fecha de Fabricación: <span className="red-text">*</span>
            </p>
            <FormCalendar
              name="manufacturingDate"
              control={control}
              width={"100%"}
              formLabel=""
              error={errors.manufacturingDate}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">
              Fecha de Importación: <span className="red-text">*</span>
            </p>
            <FormCalendar
              name="importDate"
              control={control}
              width={"100%"}
              formLabel=""
              error={errors.importDate}
              margin={"0"}
              disabled={isViewer}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="HContainer">
              <p className="create-label ml-0">
                Vida util: <span className="red-text">*</span>
              </p>
              {Boolean(serieIdSelected) && serieIdSelected !== 0 && (
                <div className="pointer align-center j-center ml-10">
                  <StyledTooltip
                    title={getTooltipContent(
                      biomedicalEquipmentData.manufacturingDate ||
                        biomedicalEquipmentData.importDate,
                      biomedicalEquipmentData.useful_life_id
                    )}
                    followCursor
                  >
                    <img
                      className="btn-icon-20"
                      src={icons.infoExclamation}
                      alt="icon"
                      style={{ display: "block" }}
                    />
                  </StyledTooltip>
                </div>
              )}
            </div>
            <FormTextField
              name="useful_life"
              control={control}
              type="number"
              min={3}
              max={15}
              onlyNumbers
              adornmentText="Años"
              error={errors.useful_life}
            />
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}></Grid>
          {/* Accessories */}
          <Grid item xs={12}>
            <p className="create-label ml-0">Accesorios:</p>
            {isViewer ? (
              <></>
            ) : (
              <div className="j-end">
                <LaddaButton
                  width={"40px"}
                  fontSize={"12px"}
                  height={"40px"}
                  variant="contained"
                  margin={"0px 0px 0px 25px"}
                  onClick={() => {
                    if (brandIdSelected) {
                      setOpenAddAccessoryModal(true);
                    } else {
                      setSeverityState("warn");
                      setToastMessage("Es necesario seleccionar una marca");
                      setShowToast(true);
                    }
                  }}
                >
                  <img className="btn-icon" src={icons.plusIcon} alt="icon" />
                </LaddaButton>
              </div>
            )}

            <div className="mt-15">
              <SimpleTable
                data={accessoryTable}
                columns={baseAccessoryColumns}
                scrollHeight={"300px"}
                text={"Accesorios Agregados"}
                buttons={[
                  {
                    type: "icon",
                    icon: isViewer ? icons.eye : icons.editYellow,
                    onClick: (data) => {
                      setSelectedRow(data);
                      setOpenAddAccessoryModal(true);
                    }
                  }
                ]}
              />
            </div>

            <Divider className="mv-25" />

            <p className="createRist-title ml-0">Instalado</p>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              className="pv-device-form"
            >
              <Grid item xs={12} md={6}>
                <p className="create-label ml-0">Instalado:</p>
                <SimpleSelect
                  name="installed"
                  control={control}
                  options={yesNoSelect}
                  hideLabel={true}
                  error={errors.installed}
                  defaultValue={null}
                  margin={"0"}
                  disabled={isViewer}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                {watch("installed") === 1 && (
                  <>
                    <p className="create-label ml-0">Fecha de Instalación:</p>
                    <FormCalendar
                      name="installationDate"
                      control={control}
                      width={"100%"}
                      formLabel=""
                      error={errors.installationDate}
                      margin={"0"}
                      disabled={isViewer}
                    />
                  </>
                )}
              </Grid>
            </Grid>
            <p className="createRist-title ml-0">Fecha de Comercialización</p>
            <Grid container spacing={2} className="pv-device-form">
              <Grid item xs={12} md={6}>
                <p className="create-label ml-0">Fecha de Comercialización:</p>
                <FormCalendar
                  name="marketingDate"
                  control={control}
                  width={"100%"}
                  formLabel=""
                  error={errors.marketingDate}
                  margin={"0"}
                  disabled={isViewer}
                />
              </Grid>
            </Grid>
            <p className="createRist-title ml-0">Sucesos de Seguridad</p>
            <Grid container spacing={2} className="pv-device-form">
              <Grid item xs={12} md={12}>
                <p className="create-label ml-0">
                  Eventos adversos presentados:
                </p>
                <AdverseEventsTable
                  userId={userId}
                  isPageBusy={!!activeAction}
                  startProtectedAction={startProtectedAction}
                  endProtectedAction={endProtectedAction}
                  adverseEventsDataTable={adverseEventsDataTable}
                  setAdverseEventsDataTable={updateAdverseEventsDataTable}
                  isViewer={isViewer}
                  typeEventOptions={adverseEventTypeOptions}
                  gravityOptions={adverseEventGravityOptions}
                  biomedicalEquipmentId={biomedicalEquipmentId}
                  equipmentSerialNumber={
                    biomedicalEquipmentData?.serieName || serieSelected || ""
                  }
                />
              </Grid>
            </Grid>
            <p className="createRist-title ml-0">Modalidad</p>
            <Grid container spacing={2} className="pv-device-form">
              <Grid item xs={12} md={6}>
                <p className="create-label ml-0">Estado:</p>
                <SimpleSelect
                  name="state"
                  control={control}
                  options={biomedicalEquipmentState}
                  hideLabel={true}
                  error={errors.state}
                  margin={"0"}
                  disabled={isViewer}
                />
              </Grid>
            </Grid>
            <p className="createRist-title ml-0">Ubicación Actual</p>
            <p className="create-label ml-0">Ubicación Actual:</p>
            <Grid container spacing={2} className="pv-device-form">
              <Grid item xs={9} md={10}>
                <SimpleSelect
                  name="currentLocation"
                  control={control}
                  options={currentLocationSelect}
                  hideLabel={true}
                  margin={"0"}
                  error={errors.currentLocation}
                  disabled={isViewer}
                />
              </Grid>
              {isViewer || !canEditInventory ? (
                <></>
              ) : (
                <Grid item xs={3} md={2}>
                  <LaddaButton
                    height={"40px"}
                    width={"40px"}
                    margin={
                      isMediumScreen
                        ? "10px 5px"
                        : isSmallScreen
                          ? "8px 5px"
                          : "0px 5px"
                    }
                    variant="contained"
                    type="button"
                    onClick={() => setOpenAddUbication(true)}
                  >
                    <img className="btn-icon" src={icons.plusIcon} alt="icon" />
                  </LaddaButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        {isViewer ? (
          <></>
        ) : (
          <div className="j-center white-space">
            <LaddaButton
              width={"160px"}
              fontSize={"12px"}
              height={"40px"}
              variant="contained"
              onClick={handleOpenVerification}
              loading={isSavingEquipment}
              // type="submit"
              disabled={!isValid || !!activeAction || imageProcessing}
            >
              <p className="button_text">Guardar</p>
            </LaddaButton>
          </div>
        )}
      </form>
      </LoadingFeedback>
      </fieldset>
      <SelectSerieNumber
        open={openSelectSerieNumberModal}
        handleClose={hadleModalClose}
        setSerieIdSelected={setSerieIdSelected}
        setSerieSelected={setSerieSelected}
      />
      <AddSerieNumber
        onStart={() => startProtectedAction("serie")}
        onFinish={endProtectedAction}
        open={openAddSerieNumberModal}
        close={hadleModalCloseAdd}
        setSerieIdSelected={setSerieIdSelected}
        setSerieSelected={setSerieSelected}
      />
      <AddAccessoryBase
        isPageBusy={!!activeAction}
        startProtectedAction={startProtectedAction}
        endProtectedAction={endProtectedAction}
        open={openAddAccessoryModal}
        close={hadleCloseAddAccessory}
        brandIdSelected={brandIdSelected}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setAccessoryTable={updateAccessoryTable}
        accessoryTable={accessoryTable}
        isViewer={isViewer}
      />
      <AddUbicationModal
        open={openAddUbication}
        close={() => setOpenAddUbication(false)}
        getSelectsBiomedicalData={getSelectsBiomedicalData}
        userId={userId}
      />
      <HistoryModalBiomedical
        open={historyModalOpen}
        close={() => setHistoryModalOpen(false)}
        data={biomedicalEquipmentId}
      />
      <ToastNotification
        severity={severityState}
        summary={toastMessage}
        detail=""
        showToast={showToast}
        setShowToast={setShowToast}
      />
      <VerificationModal
        open={openVerification}
        handleClose={handleCloseVerification}
        loading={isSavingEquipment}
        alertText={`¿Estás seguro de ${biomedicalEquipmentId ? "editar" : "crear"} este equipo biomédico?`}
        onConfirm={handleConfirmSave}
      />
    </div>
  );
};

export default BiomedicalEquipmentBase;
